import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { AgentFilterControls } from './AgentFilterControls';
import { AppFilterControls } from './AppFilterControls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterPanel({
  open,
  onClose
}) {
  const {
    ProductType
  } = useFilterConfig();
  const params = useSearchParams();
  if (!ProductType) throw new Error('ProductType filter not found');
  const productType = params.get(ProductType.field, {
    allowedValues: ProductType.options.map(option => option.value)
  });
  if (!open) return;
  return /*#__PURE__*/_jsxs(Panel, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.panelTitle.app"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "600",
          children: [productType === 'APP' && /*#__PURE__*/_jsx(AppFilterControls, {}), productType === 'AGENT' && /*#__PURE__*/_jsx(AgentFilterControls, {})]
        })
      })
    }), /*#__PURE__*/_jsx(PanelFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.closePanel"
        })
      })
    })]
  });
}